import { render, staticRenderFns } from "./MotorQuoteList.vue?vue&type=template&id=bec04d98&"
import script from "./MotorQuoteList.vue?vue&type=script&lang=js&"
export * from "./MotorQuoteList.vue?vue&type=script&lang=js&"
import style0 from "./MotorQuoteList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MotorQuoteList.vue"
export default component.exports